import { useEffect, useState } from 'react';
import {
    Button,
    Box,
    Stack,
    Typography,
    FormControl,
    TextField,
    InputLabel,
    Select,
    MenuItem,
    Checkbox
} from '@mui/material';
import { SelectAllFromTable } from '../universal/Axios';
import { DensityNetworkConfigTable } from '../densityNetworkConfigs/DensityNetworkConfigTable';
import { ComparativeSetTable } from '../comparativeSets/ComparativeSetTable';
import apiClient from '../../apiClient';
import { getStore } from '../../Store'

const store = getStore();

const CreateNetworkBatch = () => {
    const [selectedDNCs, selectDNC] = useState([])
    const [existingComparativeSetDNCCombos, setExistingComparativeSetDNCCombos] = useState([])
    const [persisterOverrideFiles, setPersisterOverrideFiles] = useState([])
    const [existingSelectedComparativeSetDNCCombos, setExistingSelectedComparativeSetDNCCombos] = useState([])
    const [persisterConfigID, setPersisterConfigID] = useState("")
    const [networkBatchID, setNetworkBatchID] = useState("")
    const [networkBatchDescription, setNetworkBatchDescription] = useState("")
    const [errors, setErrors] = useState([])
    const [autoRun, setAutoRun] = useState(false)
    const [warnings, setWarnings] = useState([])
    const [comparativeSetID, selectComparativeSetID] = useState(undefined)


    const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState(true)


    useEffect(() => {
        SelectAllFromTable('comparative_set_density_network_config_pair', setExistingComparativeSetDNCCombos)
        SelectAllFromTable('persister_config', setPersisterOverrideFiles)
    }, [])

    useEffect(() => {
        if (existingSelectedComparativeSetDNCCombos.length > 0) {
            setWarnings("Warning: existing density network configs selected for this Comparative Set (" + existingSelectedComparativeSetDNCCombos.map(x => x + "\n") + ")")     
        }
        else {
            setWarnings("")
        }
    }, [existingSelectedComparativeSetDNCCombos])

    useEffect(() => {
        if (networkBatchID !== "" && comparativeSetID && comparativeSetID.length > 0 && selectedDNCs.length > 0 && persisterConfigID !== "") {
            setSubmitButtonDisabled(false)
        }
        else {
            setSubmitButtonDisabled(true)
        }
        setExistingSelectedComparativeSetDNCCombos(existingComparativeSetDNCCombos.filter(x => x.comparative_set_id === comparativeSetID && selectedDNCs.includes(x.density_network_config_id) && x.density_network_config_id).map(x => x.density_network_config_id))
    }, [networkBatchID, comparativeSetID, selectedDNCs, persisterConfigID]);

    const createNetworkBatch = () => {
        apiClient.post(
            "https://us-central1-airy-semiotics-297902.cloudfunctions.net/interactive-density-network",
            {
                "function_to_execute": "Create_Batch_From_Comparative_Set_ID_And_DNC_ID_List",
                "network_batch_id": networkBatchID,
                "network_batch_description": networkBatchDescription,
                "comparative_set_id": comparativeSetID,
                "dnc_id_list": selectedDNCs,
                "persister_config_id": persisterConfigID,
                "is_auto_run": autoRun ? "1" : "0"
            }
        ).then(() => {
            store.updateSuccessMessage("Successfully generated network batch!")
            window.location.href = "/edit-network-batch?id=" + networkBatchID
        }).catch(function (error) {
            if (error?.response?.status === 401) {
                //handleautherror(dispatch)
            } else {

            }
        });
    }

    return (
        <Box>
            <Typography variant="h5">Create Network Batch</Typography>
            <Box sx={{ height: '80px' }}>
                <FormControl style={{ width: '15%', marginTop: '25px', marginRight: '20px' }}>
                    <TextField
                        id="id"
                        label="Network Batch ID"
                        onChange={(event) => setNetworkBatchID(event.target.value)}
                        required
                        defaultValue={networkBatchID}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
                <FormControl style={{ width: '80%', marginTop: '25px' }}>
                    <TextField
                        id="description"
                        label="Description"
                        onChange={(event) => setNetworkBatchDescription(event.target.value)}
                        defaultValue={networkBatchDescription}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </FormControl>
            </Box>
            <Box>
                <FormControl style={{ width: '216px', marginTop: '20px' }}>
                    <InputLabel id="persister_config">Persister Config</InputLabel>
                    <Select
                        id="persister_config"
                        label="Persister Config"
                        value={persisterConfigID}
                        variant="outlined"
                        onChange={(event) => setPersisterConfigID(event.target.value)}
                    >
                        <MenuItem value={""} style={{ display: "block" }}></MenuItem>
                        {persisterOverrideFiles && persisterOverrideFiles?.map(x => <MenuItem value={x.id} style={{ display: "block" }}>{x.id}</MenuItem>)}
                    </Select>
                </FormControl>
                <Box sx={{ height: '40px', marginTop: '10px' }}>
                    <Checkbox
                        checked={autoRun}
                        onClick={() => setAutoRun(!autoRun)}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28, marginTop: '-5px' } }}
                    />  <span style={{ width: '45%', fontSize: '1.3rem' }}>Auto Run </span>
                </Box>
            </Box>
            <Box sx={{ height: warnings.length > 0 ? '40px' : '0px',marginTop: '10px' }}>
                <b>Selected Density Network Configs:</b> {selectedDNCs.map(x => x + "; ")}
            </Box>
            <Box sx={{ height: warnings.length > 0 ? '20px' : '0px', color: "#eb9834", marginTop: '10px' }}>
                {warnings}
            </Box>
            <Box sx={{ m: 2, height: '10px', }}>
                <Box style={{ width: '48%', height: '10px', display: 'inline-block', float: 'left' }}>
                    <h3>
                        Comparative Sets
                    </h3>
                    <div style={{ height: '450px' }}>
                        <ComparativeSetTable selectComparativeSetID={selectComparativeSetID} selectedComparativeSetID={comparativeSetID} />
                    </div>
                    <Box sx={{ m: 2 }}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" href={"batch-results"}>Cancel</Button>
                            <Button variant="outlined" onClick={() => createNetworkBatch()} disabled={isSubmitButtonDisabled}>Submit</Button>
                        </Stack>
                    </Box>
                </Box>
                <Box style={{ width: '48%', height: '500px', display: 'inline-block', float: 'right' }}>
                    <h3>
                        Density Network Configs
                    </h3>
                    <DensityNetworkConfigTable parent_id="all" selectDensityNetworkConfig={selectDNC} selectedDensityNetworkConfig={selectedDNCs} />
                </Box>
            </Box>
        </Box>
    )
}

export default CreateNetworkBatch;
